/*@flow*/
/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import Map from './Map';
import Header from './Header';
import {
  LEVEL,
  BREAKPOINT_MD,
  BREAKPOINT_MD_MAP_HEIGHT,
} from 'store/constants';
import Nav from './Nav';
import Footer from './Footer';
import styled from '@emotion/styled';

const Grid = styled.div`
  display: grid;
  grid-gap: 0px;
  grid-template-columns: repeat(auto-fit, minmax(180px, auto));
  grid-auto-rows: minmax(180px, auto);
  grid-auto-flow: dense;
  width: 100%;
`;

const Component = (props: { decks: Object[], children?: React$Node }) => {
  return (
    <div>
      <Header />
      <Nav />
      <div
        css={css(`
          background: var(--brand-black);
          display: grid;
          grid-template-columns: 30% 70%;
          min-height: 800px;

          @media (max-width: ${BREAKPOINT_MD.toString()}) {
            grid-template-columns: 100%;
            grid-template-rows: ${BREAKPOINT_MD_MAP_HEIGHT.toString()} 1fr;
          }
        `)}
      >
        <div
          css={css(`
            height: calc(100vh - 45px);
            position: sticky;
            top: 40px;
            z-index: ${LEVEL.MAP_COLUMN};
            @media (max-width: ${BREAKPOINT_MD.toString()}) {
              height: ${BREAKPOINT_MD_MAP_HEIGHT.toString()};
              top: 0px;
            }
          `)}
        >
          <Map
            center={[-73.98465991, 40.68922144]}
            mapHeight="inherit"
            zoom={14}
            decks={props.decks}
          />
        </div>
        <div
          css={css(`
          background: var(--brand-black);
          padding: 0 10px;
          @media (max-width: ${BREAKPOINT_MD.toString()}) {
            padding: 0;
          }
        `)}
        >
          <Grid>
            {props.children || null}
            <Footer />
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default Component;
